// src/services/subirNivel.js
import axios from "axios";
import { rutas } from "../rutas/rutas";
import { getCookie } from "../utils/getCookies";

/**
 * subirNivelServices (FIX DEFINITIVO)
 * - Si detecta molino => SIEMPRE usa rutas.molinoSubirNivel (/api/molino/subirNivel)
 * - Para land => usa rutas.edificaciones (/api/edificaciones)
 * - Retorna SIEMPRE res.data
 *
 * Detecta MOLINO por:
 *  - opts.mode === "molino"
 *  - opts.isMolino === true
 *  - id === 20 (fallback legacy)
 */
export const subirNivelServices = async (id, opts = {}) => {
  const token = getCookie("token");

  const numericId = Number(id ?? 0);

  const forceMolino =
    opts?.mode === "molino" ||
    opts?.isMolino === true ||
    numericId === 20; // ✅ fallback duro

  const url = forceMolino ? rutas?.molinoSubirNivel : rutas?.edificaciones;

  // ✅ GUARD: si no existe el endpoint, no llames axios
  if (!url || typeof url !== "string") {
    throw new Error(
      forceMolino
        ? "RUTA_MOLINO_SUBIR_NIVEL_UNDEFINED (define rutas.molinoSubirNivel)"
        : "RUTA_EDIFICACIONES_UNDEFINED (define rutas.edificaciones)"
    );
  }

  // ✅ Para molino NO necesitas mandar id (pero si lo mandas no molesta).
  // Para land sí.
  const data = forceMolino ? {} : { id: numericId };

  const res = await axios({
    url,
    data,
    method: "post",
    headers: { token },
  });

  return res.data;
};
